import { SearchTaskRequestTaskDue, Stages } from '@urbanx/agx.activities.client';
import { TaskFilterState } from 'pages/allTasks/TaskFilters/TaskFiltersState';
import { TasksSearchFilterType } from './TasksSearchFilterType';

export const CreateTaskFilterState = (
  searchFilterType: TasksSearchFilterType,
  assignedToUserIds?: string[],
  agencies?: string[]
): TaskFilterState => {
  const searchRequest: TaskFilterState = {
    states: undefined,
    teamTypes: undefined,
    assignedToUserIds: assignedToUserIds,
    agencyIds: agencies,
    stages: undefined,
    taskDue: SearchTaskRequestTaskDue.Today,
  };

  switch (searchFilterType) {
    case TasksSearchFilterType.Launches:
      searchRequest.stages = [Stages.Launch];
      break;
    case TasksSearchFilterType.Deposits:
      searchRequest.stages = [Stages.Deposits];
      break;
    case TasksSearchFilterType.Conditions:
      searchRequest.stages = [Stages.Conditions];
      break;
    case TasksSearchFilterType.Settlements:
      searchRequest.stages = [Stages.Settlement];
      break;
    case TasksSearchFilterType.Terminations:
      searchRequest.stages = [Stages.Termination];
      break;
    case TasksSearchFilterType.Overdue:
      searchRequest.taskDue = SearchTaskRequestTaskDue.Overdue;
      break;
  }

  return searchRequest;
};
